import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {SfaContactHdrContainerModel} from '../../../../../models';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../shared';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SfaContactHdrService extends BaseApiTemplateService<SfaContactHdrContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sfa-contact-hdr/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.SFA_MODULE_PREFIX + 'sfa-contact-hdr/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'sfa-contact-hdr/backoffice-ep';
    this.httpClient = http;
  }

  createTempContact(hdr: SfaContactHdrContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<SfaContactHdrContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.SFA_MODULE_PREFIX + 'sfa-contact-hdr/temp/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.SFA_MODULE_PREFIX + 'sfa-contact-hdr/temp/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<SfaContactHdrContainerModel>>(url, hdr, this.getHttpHeader(visa));
  }
}
